import React from "react";
import { Helmet } from "react-helmet";

function HelmetBox() {
  return (
    <Helmet>
      <link
        rel="preconnect"
        href="https://ka-f.fontawesome.com"
        crossOrigin="anonymous"
      />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://va.vercel-scripts.com" />
      <link rel="preconnect" href="https://identitytoolkit.googleapis.com" />

      <link rel="dns-prefetch" href="https://ka-f.fontawesome.com" />
      <link rel="dns-prefetch" href="https://fonts.googleapis.com" />
      <link rel="dns-prefetch" href="https://va.vercel-scripts.com" />
      <link rel="dns-prefetch" href="https://identitytoolkit.googleapis.com" />
    </Helmet>
  );
}

export default HelmetBox;
